import { openModal } from 'modal'
import LoginModal from './LoginModal'
export const openLoginModal = ({ redirectToDashboard, refresh }) => openModal(LoginModal, { redirectToDashboard, refresh })
